import keyMirror from '../helpers/keymirror';

const actionTypes = keyMirror({
  GET_SETTINGS: null,
  GET_SETTINGS_FALLBACK: null,
  SHOW_MAINTENANCE_BANNER: null,
  PLAY_DEPOSIT_VIDEO: null,
  PLAY_WITHDRAWAL_VIDEO: null,
  ENABLE_SERVER_DEGRADED_MODE_DISABLE_DEGRADED_MODE_NOTIFY_VIEW: null,
  UPDATE_APP_STATUS: null,
  START_MAINTENANCE_SYSTEM_UPDATE: null,
  START_MAINTENANCE_SYSTEM_SCHEDULED: null,
});

export default actionTypes;
